module.exports = __webpack_public_path__ + "img/ht5.705a66cb.png";